import type { LucideIcon } from 'lucide-react';
import { Building2, Mail, Phone, User } from 'lucide-react';

const fieldIcon = (Icon: LucideIcon) => <Icon size={18} strokeWidth={2} />;

export const personFieldIcons = {
  name: fieldIcon(User),
  hospital: fieldIcon(Building2),
  phoneNumber: fieldIcon(Phone),
  email: fieldIcon(Mail),
};
